import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { LineHeightByComponent } from '@df/ui/common/line-height-by.component';
import { CommonModule } from '@angular/common';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';

/**
 * Sample usage:
 *
 *     <dropdown2 [value]="sort.option"
 *               (valueChange)="sort.by($event)"
 *               [options]="sort.getOptions()">
 *         <ng-template #titleTpl>{{sort.selectionLabel}}</ng-template>
 *         <ng-template #optionTpl let-option>{{option.label}}</ng-template>
 *     </dropdown2>
 */
@Component({
    standalone: true,
    imports: [OffClickModule, LineHeightByComponent, CommonModule, HideUpComponent, ToggleModule],
    selector: 'dropdown2',
    templateUrl: './dropdown2.html',
    styleUrls: ['./dropdown2.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Dropdown2Component<T> extends DropdownComponent<T> {
    @Input() spaceBetweenOptions = true;
}
